import styled from 'styled-components';
import { colors } from 'theme';

export const InfoTitle = styled.span`
    white-space: nowrap;
    color: ${colors.grey8};
    line-height: normal;
    align-self: flex-start;
`;

export const InfoText = styled.span`
    white-space: nowrap;
    max-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.grey10};
    user-select: text;
`;

export const InfoValue = styled.span`
    user-select: text;
`;

export const InfoWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    align-items: center;
    user-select: none;
`;
